// Geteilte Chart-Geometrie für das Investor-Deck: der Server rendert die SVGs,
// app.js rechnet beim Szenario-Wechsel mit identischer Logik neu.

export const CHART_W = 600;
export const CHART_H = 220;
export const CHART_PAD = 6;

// Rundet eine Achsen-Obergrenze auf einen ruhigen Wert auf (1/2/2,5/5 × 10^n).
export function niceMax(v: number): number {
  if (v <= 0) return 1;
  const mag = Math.pow(10, Math.floor(Math.log10(v)));
  for (const m of [1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10]) {
    if (v <= m * mag) return m * mag;
  }
  return 10 * mag;
}

export function lineY(value: number, lo: number, hi: number): number {
  const t = (value - lo) / (hi - lo || 1);
  return CHART_H - CHART_PAD - t * (CHART_H - 2 * CHART_PAD);
}

// Punktliste "x,y x,y …" für eine Polyline über die volle Breite.
export function linePoints(values: number[], lo: number, hi: number): string {
  const n = values.length;
  return values
    .map((v, i) => {
      const x = CHART_PAD + (i / (n - 1 || 1)) * (CHART_W - 2 * CHART_PAD);
      return `${Math.round(x * 10) / 10},${Math.round(lineY(v, lo, hi) * 10) / 10}`;
    })
    .join(" ");
}

// Balken (x, y, w, h) für Jahreswerte; trägt negative Werte unter der Nulllinie.
export function barRects(values: number[], lo: number, hi: number): { x: number; y: number; w: number; h: number; neg: boolean }[] {
  const n = values.length;
  const slot = (CHART_W - 2 * CHART_PAD) / n;
  const w = Math.min(72, slot * 0.56);
  const zero = lineY(0, lo, hi);
  return values.map((v, i) => {
    const x = CHART_PAD + slot * i + (slot - w) / 2;
    const y = lineY(Math.max(v, 0), lo, hi);
    const h = Math.abs(zero - lineY(v, lo, hi));
    return { x: Math.round(x * 10) / 10, y: Math.round((v >= 0 ? y : zero) * 10) / 10, w: Math.round(w * 10) / 10, h: Math.max(1.5, Math.round(h * 10) / 10), neg: v < 0 };
  });
}

// Kompakte Euro-Formate: 6,6 Mio € · 173 T€ · 395 €
export function fmtEuro(v: number): string {
  const abs = Math.abs(v);
  const sign = v < 0 ? "−" : "";
  if (abs >= 1e6) return sign + (abs / 1e6).toLocaleString("de-DE", { maximumFractionDigits: 1 }) + " Mio €";
  if (abs >= 1e3) return sign + Math.round(abs / 1e3).toLocaleString("de-DE") + " T€";
  return sign + Math.round(abs).toLocaleString("de-DE") + " €";
}

export function fmtInt(v: number): string {
  return Math.round(v).toLocaleString("de-DE");
}

export function fmtPct(v: number, digits = 2): string {
  return v.toLocaleString("de-DE", { minimumFractionDigits: digits, maximumFractionDigits: digits }) + " %";
}
